import { useState, useEffect, useCallback } from "react";

const API = window.location.origin;
const C = {
  bg: "#FAF7F2", surface: "#FFFFFF", surfaceAlt: "#F5F0E8", card: "#FFFFFF",
  border: "#E8E0D4", borderLight: "#F0EBE3", text: "#1A1A1A", textMid: "#5C564E",
  textMuted: "#9A9389", accent: "#E8593C", accentSoft: "rgba(232,89,60,0.08)",
  green: "#2D8C3C", greenSoft: "rgba(45,140,60,0.08)", red: "#EF4444",
  redSoft: "rgba(239,68,68,0.12)", blue: "#2563EB", blueSoft: "rgba(37,99,235,0.08)",
  gold: "#D4920A", goldSoft: "rgba(212,146,10,0.08)",
};

const api = {
  getToken: () => sessionStorage.getItem("mise_token"),
  headers: () => ({ "Content-Type": "application/json", Authorization: "Bearer " + sessionStorage.getItem("mise_token") }),
  async fetch(path, opts = {}) {
    const res = await fetch(API + path, { ...opts, headers: { ...api.headers(), ...opts.headers } });
    if (res.status === 401) { sessionStorage.clear(); window.location.reload(); return null; }
    return res.json();
  },
  get: (p) => api.fetch(p),
  post: (p, b) => api.fetch(p, { method: "POST", body: JSON.stringify(b) }),
  put: (p, b) => api.fetch(p, { method: "PUT", body: JSON.stringify(b) }),
  patch: (p, b) => api.fetch(p, { method: "PATCH", body: JSON.stringify(b) }),
};

const ROLES = { garcom: "Garcom", cozinha: "Cozinha", caixa: "Caixa" };

export default function EquipeTab() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "garcom" });
  const [resetPw, setResetPw] = useState({ id: null, password: "" });
  const [msg, setMsg] = useState("");

  const loadUsers = useCallback(async () => {
    setLoading(true);
    const data = await api.get("/api/users");
    if (data) setUsers(data);
    setLoading(false);
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const handleCreate = async () => {
    if (!form.name || !form.email || !form.password) { setMsg("Preencha todos os campos"); return; }
    const res = await api.post("/api/users", form);
    if (res && !res.error) {
      setShowForm(false);
      setForm({ name: "", email: "", password: "", role: "garcom" });
      setMsg("");
      loadUsers();
    } else {
      setMsg(res?.error || "Erro ao criar");
    }
  };

  const handleEdit = async () => {
    if (!editUser) return;
    const res = await api.put("/api/users/" + editUser.id, { name: editUser.name, email: editUser.email, role: editUser.role });
    if (res && !res.error) {
      setEditUser(null);
      loadUsers();
    } else {
      setMsg(res?.error || "Erro ao editar");
    }
  };

  const handleToggle = async (id) => {
    await api.patch("/api/users/" + id + "/toggle-active");
    loadUsers();
  };

  const handleResetPw = async () => {
    if (!resetPw.password || resetPw.password.length < 4) { setMsg("Senha minimo 4 caracteres"); return; }
    const res = await api.patch("/api/users/" + resetPw.id + "/reset-password", { password: resetPw.password });
    if (res && res.success) {
      setResetPw({ id: null, password: "" });
      setMsg("Senha alterada!");
      setTimeout(() => setMsg(""), 2000);
    } else {
      setMsg(res?.error || "Erro");
    }
  };

  const inputStyle = {
    width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid " + C.border,
    background: C.bg, color: C.text, fontSize: 14, fontFamily: "'DM Sans',sans-serif",
    outline: "none", boxSizing: "border-box",
  };

  const btnStyle = (bg, color) => ({
    padding: "10px 20px", borderRadius: 8, border: "none", background: bg,
    color: color || "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer",
    fontFamily: "'DM Sans',sans-serif",
  });

  return (
    <div style={{ padding: "28px 32px", maxWidth: 900 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: C.text, fontFamily: "'Playfair Display',serif", margin: 0 }}>Equipe</h2>
          <p style={{ fontSize: 13, color: C.textMuted, margin: "4px 0 0" }}>Gerencie garcons e funcionarios</p>
        </div>
        <button onClick={() => { setShowForm(!showForm); setEditUser(null); setMsg(""); }} style={btnStyle(C.accent)}>
          {showForm ? "Cancelar" : "+ Novo Funcionario"}
        </button>
      </div>

      {msg && <div style={{ padding: "10px 16px", borderRadius: 8, background: msg.includes("alterada") || msg.includes("sucesso") ? C.greenSoft : C.redSoft, color: msg.includes("alterada") || msg.includes("sucesso") ? C.green : C.red, fontSize: 13, marginBottom: 16 }}>{msg}</div>}

      {showForm && (
        <div style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 24, marginBottom: 24 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, color: C.text, marginBottom: 16 }}>Novo Funcionario</h3>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <input placeholder="Nome" value={form.name} onChange={e => setForm({...form, name: e.target.value})} style={inputStyle} />
            <input placeholder="Email" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} style={inputStyle} />
            <input placeholder="Senha" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} style={inputStyle} />
            <select value={form.role} onChange={e => setForm({...form, role: e.target.value})} style={inputStyle}>
              <option value="garcom">Garcom</option>
              <option value="cozinha">Cozinha</option>
              <option value="caixa">Caixa</option>
            </select>
          </div>
          <button onClick={handleCreate} style={btnStyle(C.green)}>Criar Funcionario</button>
        </div>
      )}

      {editUser && (
        <div style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 24, marginBottom: 24 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, color: C.text, marginBottom: 16 }}>Editar: {editUser.name}</h3>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <input placeholder="Nome" value={editUser.name} onChange={e => setEditUser({...editUser, name: e.target.value})} style={inputStyle} />
            <input placeholder="Email" value={editUser.email} onChange={e => setEditUser({...editUser, email: e.target.value})} style={inputStyle} />
            <select value={editUser.role} onChange={e => setEditUser({...editUser, role: e.target.value})} style={inputStyle}>
              <option value="garcom">Garcom</option>
              <option value="cozinha">Cozinha</option>
              <option value="caixa">Caixa</option>
            </select>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={handleEdit} style={btnStyle(C.blue)}>Salvar</button>
            <button onClick={() => setEditUser(null)} style={btnStyle(C.border, C.text)}>Cancelar</button>
          </div>
        </div>
      )}

      {resetPw.id && (
        <div style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 24, marginBottom: 24 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, color: C.text, marginBottom: 16 }}>Resetar Senha</h3>
          <div style={{ display: "flex", gap: 12 }}>
            <input placeholder="Nova senha" type="password" value={resetPw.password} onChange={e => setResetPw({...resetPw, password: e.target.value})} style={{...inputStyle, flex: 1}} />
            <button onClick={handleResetPw} style={btnStyle(C.gold)}>Alterar</button>
            <button onClick={() => setResetPw({ id: null, password: "" })} style={btnStyle(C.border, C.text)}>Cancelar</button>
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: "center", padding: 40, color: C.textMuted }}>Carregando...</div>
      ) : users.length === 0 ? (
        <div style={{ textAlign: "center", padding: 40, color: C.textMuted }}>Nenhum funcionario cadastrado</div>
      ) : (
        <div style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr style={{ background: C.surfaceAlt, borderBottom: "1px solid " + C.border }}>
                <th style={{ textAlign: "left", padding: "12px 16px", color: C.textMuted, fontWeight: 500, fontSize: 12, letterSpacing: 1 }}>NOME</th>
                <th style={{ textAlign: "left", padding: "12px 16px", color: C.textMuted, fontWeight: 500, fontSize: 12, letterSpacing: 1 }}>EMAIL</th>
                <th style={{ textAlign: "left", padding: "12px 16px", color: C.textMuted, fontWeight: 500, fontSize: 12, letterSpacing: 1 }}>FUNCAO</th>
                <th style={{ textAlign: "center", padding: "12px 16px", color: C.textMuted, fontWeight: 500, fontSize: 12, letterSpacing: 1 }}>STATUS</th>
                <th style={{ textAlign: "center", padding: "12px 16px", color: C.textMuted, fontWeight: 500, fontSize: 12, letterSpacing: 1 }}>ACOES</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id} style={{ borderBottom: "1px solid " + C.borderLight }}>
                  <td style={{ padding: "12px 16px", color: C.text, fontWeight: 500 }}>{u.name}</td>
                  <td style={{ padding: "12px 16px", color: C.textMid }}>{u.email}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <span style={{ padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 600, background: u.role === "owner" ? C.goldSoft : C.blueSoft, color: u.role === "owner" ? C.gold : C.blue }}>
                      {u.role === "owner" ? "Proprietario" : (ROLES[u.role] || u.role)}
                    </span>
                  </td>
                  <td style={{ padding: "12px 16px", textAlign: "center" }}>
                    <span style={{ padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 600, background: u.is_active ? C.greenSoft : C.redSoft, color: u.is_active ? C.green : C.red }}>
                      {u.is_active ? "Ativo" : "Inativo"}
                    </span>
                  </td>
                  <td style={{ padding: "12px 16px", textAlign: "center" }}>
                    {u.role !== "owner" && (
                      <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                        <button onClick={() => { setEditUser({...u}); setShowForm(false); }} title="Editar" style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid " + C.border, background: C.surface, cursor: "pointer", fontSize: 14 }}>✏️</button>
                        <button onClick={() => { setResetPw({ id: u.id, password: "" }); }} title="Resetar senha" style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid " + C.border, background: C.surface, cursor: "pointer", fontSize: 14 }}>🔑</button>
                        <button onClick={() => handleToggle(u.id)} title={u.is_active ? "Desativar" : "Ativar"} style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid " + C.border, background: u.is_active ? C.redSoft : C.greenSoft, cursor: "pointer", fontSize: 14 }}>
                          {u.is_active ? "🚫" : "✅"}
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
